import axios from 'axios'

/**
 * Rest baseurl.
 */
const baseUrl = `${process.env.wordpress}wp-json/pixels-headless/v1/`

/**
 * Get common global data
 */
const getGlobals = async (locale = false) => {
  const response = await axios.get(`${baseUrl}globals?lang=${locale}`)

  const { data } = response

  return data
}

export default {
  getGlobals,
}
